/**
 * Transient confirmations. Used by exactly one thing at launch — the Copy
 * button on the transcript page — and deliberately kept that way: a toast is
 * the right shape for "that worked", and the wrong shape for anything a user
 * has to read or act on. Errors go in a banner, where they stay put.
 */

import { el, qs } from './dom.ts';

const LIFETIME_MS = 3_000;

export function toast(message: string): void {
  const region = qs<HTMLElement>('#toast-region');
  if (!region) return;
  const node = el('div', { class: 'toast' }, [message]);
  region.append(node);
  // The region is aria-live=polite, so the text is announced by insertion.
  setTimeout(() => node.remove(), LIFETIME_MS);
}
